import type { ReactNode } from 'react';

export const symbol_location_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m485-562 30 31q9 9 22 0t13-29q0-15-5-27.5T530-610q-11-11-23.5-15.5T480-630q-20 0-28 14t2 24l31 30Zm-5-318q127 0 223.5 89T800-552q0 44-15 90t-45 97q-7 11-19 13.5t-23-4.5q-11-7-13.5-19.5T689-399q26-43 38.5-81.5T740-552q0-118-75.5-193T480-820q-45 0-85.5 13T321-768q-10 8-23 8t-21-9q-9-9-8.5-21t10.5-20q43-34 94.5-52T480-880Zm117 603L233-641q-7 20-10 42.5t-3 46.5q0 75 65 173.5T480-159q34-31 63-60.5t54-57.5ZM458.5-103.5Q448-107 440-115q-42-38-91-87.5T258-309q-42-57-70-119t-28-124q0-38 6.5-72t19.5-64L47-827q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l765 765q9 9 9 21.5T855-62q-9 9-21.5 9T812-62L640-234q-18 20-42.5 45T520-115q-8 8-18.5 11.5T480-100q-11 0-21.5-3.5ZM415-459Zm71-101Z"
		/>
	</svg>
);
